import { InspectionsCustomSortingConfiguration } from "../types/InspectionsCustomSort";
export interface IElasticsearchSort {
  field: string;
  direction: "asc" | "desc";
}

export const sort = (sort: any, idField = "_id") => {
  const missing = sort.direction === "asc" ? "_first" : "_last";
  return [{ [sort.field]: { order: sort.direction, missing } }, { [idField]: sort.direction }];
};

export const reverseSort = (sort: any, idField = "_id") => {
  const order = sort.direction === "asc" ? "desc" : "asc";
  const missing = sort.direction === "asc" ? "_last" : "_first";
  return [{ [sort.field]: { order, missing } }, { [idField]: order }];
};
//Method that takes in any object and a direction string as parameters
export const customSort = (sortConfig: InspectionsCustomSortingConfiguration, direction: string) => {
  const updateOrder = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj.map(updateOrder);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        if (key === "order") {
          acc[key] = direction;
        } else {
          acc[key] = updateOrder(value);
        }
        return acc;
      }, {} as any);
    }
    return obj;
  };

  // Start the recursion
  return updateOrder(sortConfig);
};

export default {
  sort,
  reverseSort,
  customSort,
};
